import { useCallback, useEffect, useState } from 'react';
import type { FormValues } from '@/features/cong-cu/dung-phan-bo-ccdc/khai-bao-thoi-khau-hao-ccdc/schema';
import { CongCuDungCu, CongCuDungCuResponse } from '@/types/schemas';
import { useAuth } from '@/contexts/auth-context';
import { QUERY_KEYS } from '@/constants';
import api from '@/lib/api';

interface UseCongCuDungCuReturn {
  khaiBaoThoiPhanBoCCDCs: CongCuDungCu[];
  isLoading: boolean;
  updateKhaiBaoThoiPhanBoCCDC: (uuid: string, updatedTool: any) => Promise<void>;
  refreshKhaiBaoThoiPhanBoCCDC: () => Promise<void>;
}

export const useKhaiBaoThoiPhanBoCCDC = (initialData: CongCuDungCu[] = []): UseCongCuDungCuReturn => {
  const [khaiBaoThoiPhanBoCCDCs, setKhaiBaoThoiPhanBoCCDC] = useState<CongCuDungCu[]>(initialData);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const { entity } = useAuth();

  const fetchKhaiBaoThoiPhanBoCCDC = useCallback(async (): Promise<void> => {
    if (!entity?.slug) return;

    setIsLoading(true);
    const response = await api.get<CongCuDungCuResponse>(
      `/entities/${entity.slug}/erp/${QUERY_KEYS.KHAI_BAO_THONG_TIN_CCDC}/`
    );

    const mappedData: CongCuDungCu[] = response.data.results;

    setKhaiBaoThoiPhanBoCCDC(mappedData);
    setIsLoading(false);
  }, [entity?.slug]);

  const updateKhaiBaoThoiPhanBoCCDC = async (uuid: string, updatedTool: FormValues) => {
    if (!entity?.slug) return;

    setIsLoading(true);
    const response = await api.put(`/entities/${entity.slug}/erp/${QUERY_KEYS.KHAI_BAO_THONG_TIN_CCDC}/${uuid}/`, {
      ngay_kh0: updatedTool.ngay_kh0
    });

    // Update the tool in the list
    const updatedToolData: CongCuDungCu = response.data;

    setKhaiBaoThoiPhanBoCCDC(prev => prev.map(tool => (tool.uuid === updatedToolData.uuid ? updatedToolData : tool)));
    setIsLoading(false);
  };

  useEffect(() => {
    fetchKhaiBaoThoiPhanBoCCDC();
  }, [entity?.slug, fetchKhaiBaoThoiPhanBoCCDC]);

  return {
    khaiBaoThoiPhanBoCCDCs,
    isLoading,
    updateKhaiBaoThoiPhanBoCCDC,
    refreshKhaiBaoThoiPhanBoCCDC: fetchKhaiBaoThoiPhanBoCCDC
  };
};
